import React from 'react';
import { Outlet } from 'react-router-dom';
import { RecetaClassificationProvider } from '../../../contexts/RecetaClassificationContext';

/**
 * Envuelve el módulo de clasificación de recetas: una sola carga de jerarquía para todas las rutas hijas.
 */
function ClasificacionRecetasLayout() {
  return (
    <RecetaClassificationProvider>
      <Outlet />
    </RecetaClassificationProvider>
  );
}

export default ClasificacionRecetasLayout;
